import __request__ from "routing/request";
export function listConfigurations(sort = "name", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", "/sidecar/configurations", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createConfiguration(JSONbody, requestOptions) {
  return __request__("POST", "/sidecar/configurations", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function renderConfiguration(JSONbody, requestOptions) {
  return __request__("POST", "/sidecar/configurations/render/preview", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function renderConfigurationBysidecarIdAndconfigurationId(sidecarId, configurationId, requestOptions) {
  return __request__("GET", `/sidecar/configurations/render/${sidecarId}/${configurationId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validateConfiguration(configuration, requestOptions) {
  return __request__("POST", "/sidecar/configurations/validate", configuration, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteConfiguration(id, requestOptions) {
  return __request__("DELETE", `/sidecar/configurations/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateConfiguration(id, JSONbody, requestOptions) {
  return __request__("PUT", `/sidecar/configurations/${id}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getConfigurations(id, requestOptions) {
  return __request__("GET", `/sidecar/configurations/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getConfigurationSidecars(id, requestOptions) {
  return __request__("GET", `/sidecar/configurations/${id}/sidecars`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function copyConfiguration(id, name, requestOptions) {
  return __request__("POST", `/sidecar/configurations/${id}/${name}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
